import { FC } from 'react';
import { Link } from 'react-router-dom';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { IconButton, rem, UserAddOutline } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';

export const InviteUsersCTANavButton: FC = () => {
	const { track } = useAnalytics();
	const dispatch = useDispatch();

	const onInviteByMailClick = () => {
		track(AnalyticsEvent.TopNavbar.InviteByEmailDropdown);
		dispatch('open-user-invite-modal');
	};

	return (
		<Link to="#">
			<IconButton
				_active={{ bg: 'gray.100', transform: 'scale(0.95)' }}
				_hover={{ bg: 'gray.100' }}
				aria-label="Invite User"
				backgroundColor="gray.50"
				borderRadius="full"
				color="gray.900"
				fontSize="lg"
				height={{ base: rem(40), xs: rem(44) }}
				width={{ base: rem(40), xs: rem(44) }}
				icon={<UserAddOutline />}
				id="users-invite"
				onClick={onInviteByMailClick}
			/>
		</Link>
	);
};
